module.exports = __webpack_public_path__ + "static/polly-vernon-media-feature-02-c6d3bccd135953856dc3f5c33ba21011.jpg";